import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import type { UseUIFeatureCheck } from '../types';

export const useIsNetworkThemesEnabled: UseUIFeatureCheck = () => {
  const isGlobalCopilotFlighted = useExperimentTreatmentWithoutReporting('VivaEngageGlobalCopilot') === true;
  const isGlobalCopilotTenantFlighted =
    useExperimentTreatmentWithoutReporting('VivaEngageGlobalCopilotTenant') === true;

  return isGlobalCopilotFlighted || isGlobalCopilotTenantFlighted;
};
